import { PayoutsWrapper } from "../../components";

export default function PayoutsPage() {
  return (
    <>
      <PayoutsWrapper />
    </>
  );
}
